export default __webpack_public_path__ + "static/media/img-2.b41a5e53.jpg";